var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShopfitting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#232A2E;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3.28,
    y: 19.73,
    className: "st0",
    width: 43.45,
    height: 23.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.72,43.74H3.28c-0.28,0-0.51-0.23-0.51-0.51v-23.5c0-0.28,0.23-0.51,0.51-0.51h43.45 c0.28,0,0.51,0.23,0.51,0.51v23.5C47.23,43.51,47,43.74,46.72,43.74z M3.79,42.72h42.43V20.24H3.79V42.72z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 7.01,
    y: 25.58,
    className: "st0",
    width: 19.77,
    height: 13.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.79,39.8H7.01c-0.28,0-0.51-0.23-0.51-0.51V25.58c0-0.28,0.23-0.51,0.51-0.51h19.77 c0.28,0,0.51,0.23,0.51,0.51v13.71C27.3,39.58,27.07,39.8,26.79,39.8z M7.52,38.78h18.75V26.09H7.52V38.78z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "31.2,43.47 31.2,24.35 43.12,24.35 43.12,43.47  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.12,43.98c-0.28,0-0.51-0.23-0.51-0.51V24.86h-10.9v18.61c0,0.28-0.23,0.51-0.51,0.51 s-0.51-0.23-0.51-0.51V24.35c0-0.28,0.23-0.51,0.51-0.51h11.92c0.28,0,0.51,0.23,0.51,0.51v19.12 C43.63,43.75,43.4,43.98,43.12,43.98z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 31.21,
    y: 35.39,
    className: "st1",
    width: 11.91,
    height: 7.84
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 40.31,
    cy: 32.16,
    r: 1.02
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.37,3.95v6.34c0,0.29-0.23,0.51-0.51,0.51H4.1c-0.28,0-0.51-0.22-0.51-0.51V3.95 c0-0.29,0.23-0.51,0.51-0.51h41.76C46.13,3.44,46.37,3.66,46.37,3.95z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.95,17.71v1.84c0,1.79-1.44,3.23-3.22,3.23c-1.14,0-2.14-0.59-2.71-1.49c-0.58,0.9-1.58,1.49-2.72,1.49 c-1.14,0-2.14-0.59-2.71-1.5c-0.57,0.91-1.58,1.5-2.72,1.5c-1.13,0-2.13-0.59-2.71-1.49c-0.58,0.9-1.58,1.49-2.72,1.49 c-1.14,0-2.14-0.59-2.71-1.5c-0.57,0.91-1.57,1.5-2.71,1.5s-2.14-0.59-2.72-1.49c-0.58,0.9-1.58,1.49-2.71,1.49 c-1.14,0-2.15-0.59-2.72-1.5c-0.57,0.91-1.57,1.5-2.71,1.5c-1.14,0-2.14-0.59-2.72-1.49c-0.58,0.9-1.58,1.49-2.71,1.49 c-1.14,0-2.14-0.59-2.71-1.49c-0.58,0.9-1.58,1.49-2.72,1.49C1.45,22.78,0,21.33,0,19.55v-1.84c0-0.29,0.22-0.51,0.51-0.51h48.92 C49.72,17.2,49.95,17.42,49.95,17.71z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "8.74,10.29 5.95,17.7 0.51,17.7 4.1,10.29  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.95,18.21H0.51c-0.18,0-0.34-0.09-0.43-0.24c-0.09-0.15-0.1-0.33-0.03-0.49l3.59-7.41 C3.72,9.89,3.9,9.78,4.1,9.78h4.64c0.17,0,0.32,0.08,0.42,0.22c0.1,0.14,0.12,0.31,0.06,0.47l-2.79,7.41 C6.35,18.08,6.16,18.21,5.95,18.21z M1.32,17.19h4.27L8,10.8H4.42L1.32,17.19z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "13.38,10.29 11.38,17.7 5.95,17.7 8.74,10.29  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.38,18.21H5.95c-0.17,0-0.32-0.08-0.42-0.22c-0.1-0.14-0.12-0.31-0.06-0.47l2.79-7.41 c0.07-0.2,0.27-0.33,0.48-0.33h4.64c0.16,0,0.31,0.07,0.41,0.2c0.1,0.13,0.13,0.29,0.09,0.44l-1.99,7.41 C11.82,18.05,11.61,18.21,11.38,18.21z M6.68,17.19h4.31l1.72-6.39H9.09L6.68,17.19z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "18.02,10.29 16.82,17.7 11.38,17.7 13.38,10.29  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.82,18.21h-5.44c-0.16,0-0.31-0.07-0.41-0.2c-0.1-0.13-0.13-0.29-0.09-0.44l1.99-7.41 c0.06-0.22,0.26-0.38,0.49-0.38h4.64c0.15,0,0.29,0.07,0.39,0.18c0.1,0.11,0.14,0.26,0.12,0.41l-1.2,7.41 C17.28,18.03,17.07,18.21,16.82,18.21z M12.05,17.19h4.34l1.03-6.39h-3.65L12.05,17.19z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "22.66,10.29 22.26,17.7 16.82,17.7 18.02,10.29  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.26,18.21h-5.44c-0.15,0-0.29-0.07-0.39-0.18c-0.1-0.11-0.14-0.26-0.12-0.41l1.2-7.41 c0.04-0.25,0.25-0.43,0.5-0.43h4.64c0.14,0,0.27,0.06,0.37,0.16c0.1,0.1,0.15,0.24,0.14,0.38l-0.4,7.41 C22.75,18,22.53,18.21,22.26,18.21z M17.42,17.19h4.35l0.34-6.39h-3.67L17.42,17.19z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "27.3,10.29 27.7,17.7 22.26,17.7 22.66,10.29  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.69,18.21h-5.44c-0.14,0-0.27-0.06-0.37-0.16c-0.1-0.1-0.15-0.24-0.14-0.38l0.4-7.41 c0.01-0.27,0.24-0.48,0.51-0.48h4.64c0.27,0,0.49,0.21,0.51,0.48l0.4,7.41c0.01,0.14-0.04,0.28-0.14,0.38 C27.97,18.15,27.83,18.21,27.69,18.21z M22.8,17.19h4.36l-0.34-6.39h-3.67L22.8,17.19z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "31.94,10.29 33.13,17.7 27.7,17.7 27.3,10.29  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.13,18.21h-5.44c-0.27,0-0.49-0.21-0.51-0.48l-0.4-7.41c-0.01-0.14,0.04-0.28,0.14-0.38 c0.1-0.1,0.23-0.16,0.37-0.16h4.64c0.25,0,0.46,0.18,0.5,0.43l1.2,7.41c0.02,0.15-0.02,0.3-0.12,0.41 C33.42,18.14,33.28,18.21,33.13,18.21z M28.18,17.19h4.35L31.5,10.8h-3.67L28.18,17.19z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "36.58,10.29 38.57,17.7 33.13,17.7 31.94,10.29  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.57,18.21h-5.44c-0.25,0-0.46-0.18-0.5-0.43l-1.2-7.41c-0.02-0.15,0.02-0.3,0.12-0.41 c0.1-0.11,0.24-0.18,0.39-0.18h4.64c0.23,0,0.43,0.15,0.49,0.38l1.99,7.41c0.04,0.15,0.01,0.32-0.09,0.44 C38.88,18.13,38.73,18.21,38.57,18.21z M33.57,17.19h4.34l-1.72-6.39h-3.65L33.57,17.19z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "41.22,10.29 44.01,17.7 38.57,17.7 36.58,10.29  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.01,18.21h-5.44c-0.23,0-0.43-0.15-0.49-0.38l-1.99-7.41c-0.04-0.15-0.01-0.32,0.09-0.44 c0.1-0.13,0.25-0.2,0.41-0.2h4.64c0.21,0,0.4,0.13,0.48,0.33l2.79,7.41c0.06,0.16,0.04,0.33-0.06,0.47 C44.33,18.13,44.17,18.21,44.01,18.21z M38.96,17.19h4.31l-2.41-6.39h-3.62L38.96,17.19z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "45.86,10.29 49.44,17.7 44.01,17.7 41.22,10.29  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.44,18.21h-5.44c-0.21,0-0.4-0.13-0.48-0.33l-2.79-7.41c-0.06-0.16-0.04-0.33,0.06-0.47 c0.1-0.14,0.25-0.22,0.42-0.22h4.64c0.2,0,0.37,0.11,0.46,0.29l3.59,7.41c0.08,0.16,0.07,0.34-0.03,0.49 C49.78,18.12,49.62,18.21,49.44,18.21z M44.36,17.19h4.27l-3.09-6.39h-3.58L44.36,17.19z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.5,25.07V39.8H27.3V25.07H6.5z M26.28,38.78H7.52V26.09h18.75V38.78z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "17.41,25.07 17.41,39.8 16.39,38.78 16.39,26.09  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 9.87,
    y: 29.41,
    transform: "matrix(0.707 -0.7072 0.7072 0.707 -17.6725 16.8589)",
    className: "st1",
    width: 3.29,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 9.77,
    y: 28.52,
    transform: "matrix(0.707 -0.7072 0.7072 0.707 -17.2976 16.0031)",
    className: "st1",
    width: 1.79,
    height: 0.7
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 18.93,
    y: 29.41,
    transform: "matrix(0.707 -0.7072 0.7072 0.707 -15.0156 23.2718)",
    className: "st1",
    width: 3.29,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 18.84,
    y: 28.52,
    transform: "matrix(0.707 -0.7072 0.7072 0.707 -14.6407 22.4159)",
    className: "st1",
    width: 1.79,
    height: 0.7
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50,43.62v2.44c0,0.29-0.23,0.51-0.51,0.51H0.51C0.23,46.56,0,46.34,0,46.05v-2.44 c0-0.28,0.22-0.51,0.51-0.51h48.98C49.77,43.11,50,43.34,50,43.62z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopfitting);
export default __webpack_public_path__ + "static/media/shopfitting.677ae2164298ccb1614f9484e44168cd.svg";
export { ForwardRef as ReactComponent };